import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import ServicesGrid from '../../../components/ServiceGrid';
//import Resources from './constants';
import ResourcesContent from '../../Resources/constant';

import './styles.css';
// import ReferGraphic from '../img/refer-graphic.svg';

const ReferPage = props => {
  const { role } = props;
  const { roleType, campusType } = role;

  let title;
  let studentResources = {
    StudentResources: ResourcesContent.StudentResources,
    CommunityResources: ResourcesContent.CommunityResources,
    EmergencyResources: ResourcesContent.EmergencyResources,
    AppResources: ResourcesContent.AppResources,
    StudentResourcesOther: ResourcesContent.StudentResourcesOther,
    EmergencyResourcesOther: ResourcesContent.EmergencyResourcesOther
  };
  let nonStudentResources = {
    StudentResourcesStaff: ResourcesContent.StudentResourcesStaff,
    CampusAll: ResourcesContent.CampusAll,
    StaffResources: ResourcesContent.StaffResources,
    CommunityResources: ResourcesContent.CommunityResources,
    EmergencyResources: ResourcesContent.EmergencyResources,
    AppResources: ResourcesContent.AppResources,
    StudentResourcesOther: ResourcesContent.StudentResourcesOther,
    EmergencyResourcesOther: ResourcesContent.EmergencyResourcesOther
  };

  if (roleType === 'FACULTY' && campusType === 'UTSG') {
    title = 'Resources for UTSG Staff & Faculty';
  } else if (roleType === 'STAFF' && campusType === 'UTSG') {
    title = 'Resources for UTSG Staff & Faculty';
  } else if (
    (roleType === 'STUDENT' && campusType === 'UTSG') ||
    (roleType === 'OTHER' && campusType === 'UTSG')
  ) {
    title = 'Resources for Students';
  } else if (roleType === 'FACULTY' && campusType === 'UTSC') {
    title = 'Resources for UTSC Staff & Faculty';
    nonStudentResources = {
      StudentResourcesStaff: ResourcesContent.StudentResourcesStaffUTSC,
      CampusAll: ResourcesContent.CampusAllUTSC,
      StaffResources: ResourcesContent.StaffResourcesUTSC,
      CommunityResources: ResourcesContent.CommunityResourcesUTSC,
      EmergencyResources: ResourcesContent.EmergencyResourcesUTSC,
      AppResources: ResourcesContent.AppResourcesUTSC
    };
  } else if (roleType === 'STAFF' && campusType === 'UTSC') {
    title = 'Resources for UTSC Staff & Faculty';
    nonStudentResources = {
      StudentResourcesStaff: ResourcesContent.StudentResourcesStaffUTSC,
      CampusAll: ResourcesContent.CampusAllUTSC,
      StaffResources: ResourcesContent.StaffResourcesUTSC,
      CommunityResources: ResourcesContent.CommunityResourcesUTSC,
      EmergencyResources: ResourcesContent.EmergencyResourcesUTSC,
      AppResources: ResourcesContent.AppResourcesUTSC
    };
  } else if (
    (roleType === 'STUDENT' && campusType === 'UTSC') ||
    (roleType === 'OTHER' && campusType === 'UTSC')
  ) {
    title = 'Resources for UTSC Students';
    studentResources = {
      StudentResources: ResourcesContent.StudentResourcesUTSC,
      CommunityResources: ResourcesContent.CommunityResourcesUTSC,
      EmergencyResources: ResourcesContent.EmergencyResourcesUTSC,
      AppResources: ResourcesContent.AppResourcesUTSC
    };
  } else if (roleType === 'FACULTY' && campusType === 'UTM') {
    title = 'Resources for UTM Staff & Faculty';
    nonStudentResources = {
      StudentResourcesStaff: ResourcesContent.StudentResourcesStaffUTM,
      CampusAll: ResourcesContent.CampusAllUTM,
      StaffResources: ResourcesContent.StaffResourcesUTM,
      CommunityResources: ResourcesContent.CommunityResourcesUTM,
      EmergencyResources: ResourcesContent.EmergencyResourcesUTM,
      AppResources: ResourcesContent.AppResourcesUTM
    };
  } else if (roleType === 'STAFF' && campusType === 'UTM') {
    title = 'Resources for UTM Staff & Faculty';
    nonStudentResources = {
      StudentResourcesStaff: ResourcesContent.StudentResourcesStaffUTM,
      CampusAll: ResourcesContent.CampusAllUTM,
      StaffResources: ResourcesContent.StaffResourcesUTM,
      CommunityResources: ResourcesContent.CommunityResourcesUTM,
      EmergencyResources: ResourcesContent.EmergencyResourcesUTM,
      AppResources: ResourcesContent.AppResourcesUTM
    };
  } else if (
    (roleType === 'STUDENT' && campusType === 'UTM') ||
    (roleType === 'OTHER' && campusType === 'UTM')
  ) {
    title = 'Resources for UTM Students';
    studentResources = {
      StudentResources: ResourcesContent.StudentResourcesUTM,
      CommunityResources: ResourcesContent.CommunityResourcesUTMStudent,
      EmergencyResources: ResourcesContent.EmergencyResourcesUTM,
      AppResources: ResourcesContent.AppResourcesUTM
    };
  } else if (
    campusType === 'OTHER'
  ) {
    title = 'Resources for Other';
    studentResources = {
      StudentResources: ResourcesContent.StudentResources,
      CommunityResources: ResourcesContent.CommunityResources,
      EmergencyResources: ResourcesContent.EmergencyResources,
      AppResources: ResourcesContent.AppResources,
      StudentResourcesOther: ResourcesContent.StudentResourcesOther,
      EmergencyResourcesOther: ResourcesContent.EmergencyResourcesOther
    };
    nonStudentResources = {
      StudentResourcesStaff: ResourcesContent.StudentResourcesStaff,
      CampusAll: ResourcesContent.CampusAll,
      StaffResources: ResourcesContent.StaffResources,
      CommunityResources: ResourcesContent.CommunityResources,
      EmergencyResources: ResourcesContent.EmergencyResources,
      AppResources: ResourcesContent.AppResources,
      StudentResourcesOther: ResourcesContent.StudentResourcesOther,
      EmergencyResourcesOther: ResourcesContent.EmergencyResourcesOther
    };
  }

  const displayNone = { display: "none" };
  const displayBlock = { display: "block" };

  return (
    <EducationModuleLayout
      progressStage={9}
      childTitle="Refer"
      progressType="refer"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
		{/* // Debug
		<div style={{	position: "fixed", 
				top: "10px",
			    	background: "red",
			    	color: "white",
			    	zIndex: 999
				}}><div>{campusType}<br/>{roleType}</div></div>
		*/}
              <h2 className="txt-blue no-bold no-margin">Resources</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <p>
                There’s an incredible range of on- and off-campus resources and services that’s available to the U of T 
                community. Since no one list can include them all, you may have to search out additional resources not 
                listed in this training. To help meet students where they are, you are encouraged to involve them in 
                seeking out resources specific to their needs and readiness.
              </p>
              <p>
                You can return directly to this Resource list by clicking the “<strong>Resources</strong>" tab at the top right of the page. 
                You can also use <a href="https://prod.virtualagent.utoronto.ca/" target="_blank" aria-label="NAVI External link">NAVI</a>, an anonymous virtual tool, and/or <a href="https://mentalhealth.utoronto.ca/" target="_blank" aria-label="STUDENT MENTAL HEALTH RESOURCE External Link">mentalhealth.utoronto.ca</a> to help navigate mental 
                health resources and supports.
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <section>
        <div className="container">
          {roleType === 'STUDENT' ||
            roleType === 'OTHER' ? (	
              <div>
		{/* This is for student, other */}
                <Row>
                  <Col md={10} mdOffset={1}>
                    <h3 className="text-center txt-dkblue">
                      {campusType === "OTHER" ?
                        'Campus and Community Resources for Students (Toronto Area)' :
                        'Campus Resources for Students'
                      }
                    </h3>
                    <ServicesGrid resources={
                      campusType === "OTHER" ?
                        studentResources.StudentResourcesOther :
                        studentResources.StudentResources
                    } />
                  </Col>
                </Row>
                <Row style={campusType === "OTHER" ? displayNone : displayBlock}>
                  <Col xs={10} xsOffset={1}>
                    <h3 className="text-center txt-dkblue">
                      {roleType === "OTHER" ?
                        'Community Resources for Students, Staff, and Faculty' :
                        'Community Resources for Students'
                      }
                  </h3>
                    <ServicesGrid
                      resources={studentResources.CommunityResources}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={10} xsOffset={1}>
                    <h3 className="text-center txt-dkblue">
                      Emergency Resources
                  </h3>
                    {/* campusType === "OTHER" ?
                      <p className="text-center">When supporting someone with intentions to harm themselves or others, call 911:</p> :
                      <p className="text-center"></p>
                    */}
                    <ServicesGrid resources={
                      campusType === "OTHER" ?
                        studentResources.EmergencyResourcesOther :
                        studentResources.EmergencyResources
                    } />
                  </Col>
                </Row>
                <Row style={campusType === "OTHER" ? displayNone : displayBlock}>
                  <Col xs={10} xsOffset={1}>
                    <h2 className="text-center txt-dkblue">App Resources</h2>
                    <ServicesGrid
                      //resources={ResourcesContent.CommunityResources}
                      resources={studentResources.AppResources}
                    />
                  </Col>
                </Row>
              </div>
            ) : (
              <div>
		{/* This is for faculty, staff */}
                <Row>
                  <Col xs={10} xsOffset={1}>
                    <h3 className="text-center txt-dkblue">
                      Campus Resources for Students
                    </h3>
                    <ServicesGrid resources={
                      campusType === "OTHER" ?
                        nonStudentResources.StudentResourcesOther :
                        nonStudentResources.StudentResourcesStaff
                    } />
                  </Col>
                </Row>
                <Row style={campusType === "OTHER" ? displayNone : displayBlock}>
                  <Col xs={10} xsOffset={1}>
                    <h3 className="text-center txt-dkblue">
                      Campus Resources for Students, Staff and Faculty
                  </h3>
                    <ServicesGrid resources={nonStudentResources.CampusAll} />
                  </Col>
                </Row>
                <Row style={campusType === "OTHER" ? displayNone : displayBlock}>
                  <Col xs={10} xsOffset={1}>
                    <h3 className="text-center txt-dkblue">
                      Campus Resources for Staff & Faculty
                  </h3>
                    <ServicesGrid
                      resources={nonStudentResources.StaffResources}
                    />
                  </Col>
                </Row>
                <Row style={campusType === "OTHER" ? displayNone : displayBlock}>
                  <Col xs={10} xsOffset={1}>
                    <h3 className="text-center txt-dkblue">
                      Community Resources for Students, Staff & Faculty
                  </h3>
                    <ServicesGrid
                      resources={nonStudentResources.CommunityResources}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={10} xsOffset={1}>
                    <h3 className="text-center txt-dkblue">
                      Emergency Resources
                  </h3>
                    {/*campusType === "OTHER" ?
                      <p className="text-center">When supporting someone with intentions to harm themselves or others, call 911:</p> :
                      <p className="text-center"></p>
                    */}
                    <ServicesGrid resources={
                      campusType === "OTHER" ?
                        nonStudentResources.EmergencyResourcesOther :
                        nonStudentResources.EmergencyResources
                    } />
                  </Col>
                </Row>
                <Row style={campusType === "OTHER" ? displayNone : displayBlock}>
                  <Col xs={10} xsOffset={1}>
                    <h2 className="text-center txt-dkblue">App Resources</h2>
                    <ServicesGrid
                      resources={nonStudentResources.AppResources}
                    />
                  </Col>
                </Row>
              </div>
            )}
        </div>
      </section>
      <section>
        <div className="container text-center">
          <Row>
            <Col xs={12}>
              <Button
                className="btn btn-blue previous"
                onClick={() => props.history.goBack()}
              >
                Previous
              </Button>
              <LinkContainer to={url.CASESTUDIES} className="btn btn-blue next">
                <Button>Next</Button>
              </LinkContainer>
            </Col>
          </Row>
        </div>
      </section>
    </EducationModuleLayout >
  );
};

ReferPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const ReferI = connect.role(ReferPage);

export default ReferI;



// WEBPACK FOOTER //
// ./src/containers/Refer/ReferI/index.jsx